import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { Droppable } from 'react-beautiful-dnd'

import ChartSlot from './components/ChartSlot'
import Typography from '../../../UniformComponents/Typography'

const FourByOneLayout = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div style={{ display: 'flex', gap: 5, height: '100%' }}>
            {[0, 1, 2, 3].map((i) => (
                <Droppable key={i} droppableId={`slide-${i}`}>
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="pp-chart-slots"
                        >
                            <ChartSlot
                                store={store}
                                key={`${store.activeSlide.id}-${i}`}
                                position={i}
                            />
                        </div>
                    )}
                </Droppable>
            ))}
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
            {[0, 1, 2, 3].map((i) => (
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Typography type="tiny">{store.activeSlide.question.has(i) ? store.activeSlide.question.get(i).questionLongText :  i18n.t('question')}</Typography>

                    <Typography type="tiny">{i18n.t('powerpoint.slide.base-size')}</Typography>
                </div>
            ))}
        </div>
    </div>
))

export default FourByOneLayout
